module.exports = __webpack_public_path__ + "img/not-available.2b460b49.png";